module.exports = __webpack_public_path__ + "static/media/party.703c851e.svg";